import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config"; // Use base URL variable if applicable

// Fetch Country List API
export const fetchCountryListApi = createAsyncThunk(
  "country/fetchList",
  async (_, { rejectWithValue }) => {
    try {

      const fullUrl = "https://clubnet.app/demo_nmm/Admin/countrylist";

      const { data: response } = await axios.get(fullUrl);

        return response;
    } catch (error) {
      console.error("Fetch Country List Error:", error);
      
      return rejectWithValue(
        error.response?.data?.message || error.message || "Error fetching country list"
      );
    }
  }
);



export const fetchCountryCodeListApi = createAsyncThunk(
  "countryCode/fetchList",
  async (_, { rejectWithValue }) => {
    try {

      const fullUrl = "https://clubnet.app/nmmSetups/EFFN/Backend/Member/countryCode";

      const { data: response } = await axios.get(fullUrl);

        return response;
    } catch (error) {
      console.error("Fetch Country List Error:", error);
      
      return rejectWithValue(
        error.response?.data?.message || error.message || "Error fetching country list"
      );
    }
  }
);



export const fetchWebStatsApi = createAsyncThunk(
  "webStats/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const { data: response } = await axios.get(
        "https://clubnet.app/nmmSetups/EFFN/Backend/web-stats"
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
